// CurrentSheetsList.jsx
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import SheetPreview from "./SheetPreview";

export default function CurrentSheetsList({ companyId }) {
  const [sheets, setSheets] = useState([]);
  const [selected, setSelected] = useState([]);
  const [expanded, setExpanded] = useState(null);
  
  const fetchSheets = async () => {
    try {
      const res = await api.get("/cutting/sheets", {
        params: { 
          companyId: companyId 
        }
      });
      setSheets(res.data.elements || []);
    } catch (err) {
      console.error("Ошибка загрузки листов:", err);
    }
  };

  useEffect(() => {
    if (companyId) {
      fetchSheets();
      const interval = setInterval(fetchSheets, 5000);
      return () => clearInterval(interval);
    }
  }, [companyId]);

  const toggleSelect = (id) => {
    setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const toggleSelectAll = () => {
    if (selected.length === sheets.length) setSelected([]);
    else setSelected(sheets.map((x) => x.id));
  };

  const toggleExpand = (id) => setExpanded(expanded === id ? null : id);

  const moveToPackaging = async () => {
    if (selected.length === 0) return;
    await api.patch("/cutting/sheets/move-to-packaging", { layoutingSheetsIds: selected });
    setSelected([]);
    fetchSheets();
  };

  const downloadSheet = async (id) => {
    const response = await api.post(`/cutting/sheets/download/${id}`, null, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    const cd = response.headers["content-disposition"];
    let fileName = "sheet.dxf";
    if (cd) {
      const utf8Match = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
      const asciiMatch = cd.match(/filename\s*=\s*["']?([^;"']+)["']?/i);
      if (utf8Match && utf8Match[1]) {
        try { fileName = decodeURIComponent(utf8Match[1]); } catch { fileName = utf8Match[1]; }
      } else if (asciiMatch && asciiMatch[1]) {
        fileName = asciiMatch[1];
      }
    }
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <div>
          <button
            className="btn btn-warning me-2"
            disabled={selected.length === 0}
            onClick={moveToPackaging}
          >
            Передать на упаковку ({selected.length})
          </button>
        </div>
      </div>

      {/* Выбрать все */}
      {sheets.length > 0 && (
        <div className="d-flex align-items-center mb-2">
          <input
            type="checkbox"
            className="form-check-input me-2"
            checked={selected.length === sheets.length}
            ref={(el) => el && (el.indeterminate = selected.length > 0 && selected.length < sheets.length)}
            onChange={toggleSelectAll}
          />
          <span>Выбрано {selected.length} из {sheets.length}</span>
        </div>
      )}

      {sheets.map((s) => (
        <div key={s.id} className="border rounded p-2 mb-2">
          <div className="d-flex justify-content-between" style={{ cursor: "pointer" }} onClick={() => toggleExpand(s.id)}>
            <div className="d-flex">
              <input
                type="checkbox"
                className="form-check-input me-3"
                checked={selected.includes(s.id)}
                onClick={(e) => e.stopPropagation()}
                onChange={() => toggleSelect(s.id)}
              />
              <div>
                <div className="fw-bold">{s.name}</div>
                <small className="text-muted">{new Date(s.creationTime).toLocaleString()}</small>
              </div>

              <div>
                {s.cutMachineType == 2 && (
                  <span className="ms-2 badge bg-primary">Плоттер</span>
                )}
                {s.isNew === true && (
                  <span className="ms-2 badge bg-success">Новый</span>
                )}
              </div>
            </div>

            <div className="col-md-3 col-6">
              <small className="text-muted d-block">Создатель:</small>
              <div>{s.createdBy}</div>
            </div>
          </div>

          {expanded === s.id && (
            <div className="card-footer d-flex flex-column gap-2">
              <div className="mt-2">
                <SheetPreview jobId={s.jobId} />
              </div>

              <div className="d-flex flex-wrap gap-2">
                <button
                  className="btn btn-outline-success"
                  onClick={(e) => { e.stopPropagation(); downloadSheet(s.id); }}
                >
                  {s.cutMachineType == 2 ? "Скачать .ArmsData" : "Скачать .dxf"}
                </button>
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
}